export default "__VITE_ASSET__b3de545b__"